import { useIntl } from "react-intl";
import useTranslateStation from "hooks/useTranslateStation";
import { formatDate, formatTime } from "utils/formatUtils";
import Arrow from "components/Arrow";
import useFormatDuration from "hooks/useFormatDuration";
import TrainLogo from "components/TrainLogo";
import useFormatDateToLocaleString from "hooks/useFormatDateToLocaleString";
import { ScheduleType } from "types/scheduleType";
import { SeatDetails } from "components/seat/Seat";
import useFormatSeatDetails from "hooks/useFormatSeatDetails";
import { getAdultsNumber, getChildrenNumber } from "utils/urlSearchParamsUtils";
import CardLayout from "components/layout/CardLayout";
import { providerClasses } from "utils/tailwindUtils";

interface TravelInfoSectionProps {
  schedule: ScheduleType;
  seats: SeatDetails[];
}

const TravelInfoSection = ({ schedule, seats }: TravelInfoSectionProps) => {
  const intl = useIntl();
  const formatDuration = useFormatDuration();
  const formatDateTime = useFormatDateToLocaleString();
  const formatSeatDetails = useFormatSeatDetails();
  const translateStation = useTranslateStation();

  const adults = getAdultsNumber();
  const children = getChildrenNumber();

  const date = formatDate(schedule.dptDt);
  // const trainType = trainGroupCodeMap[`${schedule.trnGpCd}`] || "Unknown";
  const trainNumber = schedule.trnNo;
  const departureTime = formatTime(schedule.dptTm);
  const arrivalTime = formatTime(schedule.arvTm);
  const duration = formatDuration(schedule.runHm);
  const departureName = schedule.dptRsStnNm;
  const arrivalName = schedule.arvRsStnNm;
  // const seat = seats[0];
  const stlbTrnClsfCd = schedule.stlbTrnClsfCd;

  // // trnPsgTpCd 및 trnPsrmClCd에 해당하는 요소 찾기
  // const discountDetails = trainParams.costDetails?.find(
  //   (detail) => detail.trnPsgTpCd === "1" && detail.trnPsrmClCd === "1"
  // );

  // // sellDscntRt 값이 존재하면 사용, 그렇지 않으면 0
  // const discountRate = discountDetails ? discountDetails.sellDscntRt : 0;

  const getHeader = () => {
    return (
      <div className="flex w-full justify-between">
        <p className="font-bold">
          {intl.formatMessage({ id: "trainMain.dateOfDeparture" })}
        </p>
        <p>
          {date} ({formatDateTime(date, { weekday: "short" })})
        </p>
      </div>
    );
  };

  const getAdditionalInfo = () => {
    return (
      <div className="mt-2 w-full space-y-2 text-sm">
        <div className="flex w-full justify-between">
          <p className="font-bold">
            {intl.formatMessage({ id: "booking.passengers" })}
          </p>
          <p>
            {intl.formatMessage(
              { id: "booking.passengersDetail" },
              {
                total: adults + children,
                adults,
                children,
              }
            )}
          </p>
        </div>
        {/* Seat Details */}
        <div className="flex w-full justify-between">
          <p className="font-bold">
            {intl.formatMessage({ id: "booking.seats" })}
          </p>
          <p>{formatSeatDetails(seats)}</p>
        </div>
      </div>
    );
  };

  return (
    <CardLayout header={getHeader()} additionalInfo={getAdditionalInfo()}>
      {/* <Stack
        justifyContent="space-between"
        alignItems="center"
        direction="row"
        gap={2}
        sx={{ width: "100%" }}
      > */}
      <div className="flex items-center gap-2">
        <TrainLogo stlbTrnClsfCd={stlbTrnClsfCd} />
        <p className={`${providerClasses["text-primary"]} text-sm font-bold`}>
          {trainNumber}
        </p>
      </div>
      {/* {ProviderUtils.discountAvailable && discountRate !== 0 && (
          <Typography
            component="p"
            variant="caption"
            sx={{
              backgroundColor: theme.palette.error.main,
              color: theme.palette.error.contrastText,
              borderRadius: "8px",
              px: 1,
              py: 0.2,
              textAlign: "center",
              wordBreak: "keep-all",
              maxWidth: "60%",
            }}
          >
            {intl.formatMessage(
              { id: "booking.pointMessage" },
              { rate: discountRate }
            )}
          </Typography>
        )} 
     </Stack> */}
      <div className="w-fyll flex items-center justify-between px-4 text-center">
        <div className="space-y-1">
          <p className="text-2xl">{departureTime}</p>
          <p>{translateStation(departureName)}</p>
        </div>
        <div className="flex flex-col items-center justify-center gap-1">
          <Arrow />
          <p>{duration}</p>
        </div>
        <div className="space-y-1">
          <p className="text-2xl">{arrivalTime}</p>
          <p>{translateStation(arrivalName)}</p>
        </div>
      </div>
    </CardLayout>
  );
};

export default TravelInfoSection;
